<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 mb-4">
            <div class="each-footer">
              <h3 class="footer-heading">CONTACT</h3>
              <p>
                Ashesi University<br />1 University Avenue<br />Berekuso,
                Eastern Region<br />Ghana<br />info@ghanacic.org
              </p>
              <p><b>Phone:</b> +(233)30 261 0330</p>
              <p><b>Email:</b> info@ghanacic.org</p>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3  mb-4">
            <div class="each-footer">
              <h3 class="footer-heading">Quick Links</h3>
              <ul>
                <li>
                  <a href="https://incubator.ghanacic.org/"
                    >Incubating Innovation Symposium - 2019</a
                  >
                </li>
                <li><a href="http://www.ghanacic.org/events/">Events</a></li>
                <li><a href="http://www.ghanacic.org/about/">About Us</a></li>
                <li><a href="http://www.ghanacic.org/results/">Results</a></li>
                <li><a href="http://www.ghanacic.org/news/">News</a></li>
                <li><a href="http://www.ghanacic.org/careers/">Careers</a></li>
              </ul>
            </div>
          </div>
          <div class="col-12 col-md-12 col-lg-6  mb-4">
            <div class="each-footer">
              <h3 class="footer-heading">SUBSCRIBE TO NEWSLETTER</h3>
              <form
                v-if="!subscribed && !awaitingEmailResponse"
                v-on:submit.prevent="subscrbe"
              >
                <div class="input-group news-letter">
                  <input
                    class="form-control"
                    id="subscriber"
                    name="subscriber"
                    placeholder="Email"
                    v-model="email"
                    type="email"
                  />
                  <div class="input-group-addon p-0 m-0">
                    <button type="submit" class="btn btn-success">
                      Subscribe
                    </button>
                  </div>
                </div>
              </form>
              <div v-else-if="subscribed && !awaitingEmailResponse">
                Thank you.
              </div>
              <div v-if="awaitingEmailResponse" style="margin-left: 40px;">
                <div class="loader"></div>
              </div>
              <div v-if="subscriptionError">
                Something went wrong, please try again
              </div>
              <div class="footer-social text-center text-lg-left">
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <a href="https://www.facebook.com/GhCIC/" target="_blank"
                      ><i class="fa fa-facebook-square"></i
                    ></a>
                  </li>
                  <li class="list-inline-item">
                    <a href="https://twitter.com/GhaCIC" target="_blank"
                      ><i class="fa fa-twitter"></i
                    ></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="https://www.linkedin.com/company/ghana-climate-innovation-centre"
                      target="_blank"
                      ><i class="fa fa-linkedin-square"></i
                    ></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="https://www.youtube.com/channel/UC_PhHiuga1MaaEsVIFejwIA/featured"
                      target="_blank"
                      ><i class="fa fa-youtube-play"></i
                    ></a>
                  </li>
                  <li class="list-inline-item">
                    <a
                      href="https://www.instagram.com/ghanacic/"
                      target="_blank"
                      ><i class="fa fa-instagram"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="site-info text-center">
          <p class="mb-0">
            &copy; Ghana Climate Innovation Center. All rights reserved<br />
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Footer",
  data: function() {
    return {
      email: "",
      awaitingEmailResponse: false,
      subscribed: false,
      subscriptionError: false
    };
  },
  methods: {
    subscrbe: function() {
      if (this.email) {
        this.subscriptionError = false;
        var api_key = "26b6b97c-7a58-46d9-99bf-d8ef95f1d9bb";
        var base_url = "http://api.qikli-mail.com/v2/contact/quickadd";
        var url = `${base_url}?request=&apikey=${api_key}&emails=${this.email}`;
        this.awaitingEmailResponse = true;
        axios.post(url).then(r => {
          if (r.data.success == false) {
            this.subscriptionError = true;
          } else if (r.data.success == true) {
            this.subscribed = true;
          }
          this.awaitingEmailResponse = false;
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader {
  border: 6px solid #f3f3f3; /* Light grey */
  border-top: 6px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/elements/Footer.vue